$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery(document).ready(function($) {
    if ($("#shopify-section-featured-collections h2").length) {
        $(window).on('resize scroll', function () {
            if ($("#shopify-section-featured-collections h2").isInViewport()) {
                if ($("#shopify-section-featured-collections h2 .bones").offset().top / 2 - $(window).scrollTop()<26) {
                    if (parseInt($("#shopify-section-featured-collections h2 .bones").css('top').replace('px',''))<-39) {
                        $("#shopify-section-featured-collections h2 .bones").addClass('inViewport');
                    }
                } else {
                    $("#shopify-section-featured-collections h2 .bones").removeClass('inViewport');
                }
            } else {
                $("#shopify-section-featured-collections h2 .bones").removeClass('inViewport');
            }

            if($("#shopify-section-feature-row").isInViewport()) {
                $("#shopify-section-feature-row .feature-row__item-bg").addClass('inViewport');
            }
        });
    }

    if ($("#shopify-section-feature-row").length) {
        $(window).on('resize scroll', function () {
            if ($("#shopify-section-feature-row").isInViewport()) {
                $("#shopify-section-feature-row .feature-row__item-bg").addClass('inViewport');
            }
        });
    }

    $('.account-sidebar ul li a').on('click', function(e) {
        if($(this).data('target')!="") {
        $(this).closest('ul').find('a').removeClass('active');
        $(this).addClass('active');
        $('.account-details-container').hide();
        $($(this).data('target')).show();
        }
    });

    if($('body').hasClass('template-customers-account')) {
        if (window.location.hash != "") {
        if (window.location.hash == "#order-history") {
            $('.account-sidebar ul li a[href="' + window.location.hash+'"]').trigger('click');
        }
        }
    }

    if($('.lightning-red').length) {
        setInterval(function () {
            if ($('.header-lightnings .lightning-left').hasClass('lightning-red')) {
                $('.header-lightnings .lightning-left').removeClass('lightning-red');
                $('.header-lightnings .lightning-center').addClass('lightning-red');
            } else if ($('.header-lightnings .lightning-center').hasClass('lightning-red')) {
                $('.header-lightnings .lightning-center').removeClass('lightning-red');
                $('.header-lightnings .lightning-right').addClass('lightning-red');
            } else {
                $('.header-lightnings .lightning-right').removeClass('lightning-red');
                $('.header-lightnings .lightning-left').addClass('lightning-red');
            }
        }, 1500);
    }

    if ($('.lightning-active').length) {
        setInterval(function () {
            if ($('.light-set1 .lightning-left').hasClass('lightning-active')) {
                $('.light-set1 .lightning-left').removeClass('lightning-active');
                $('.light-set1 .lightning-center').addClass('lightning-active');
            } else if ($('.light-set1 .lightning-center').hasClass('lightning-active')) {
                $('.light-set1 .lightning-center').removeClass('lightning-active');
                $('.light-set1 .lightning-right').addClass('lightning-active');
            } else {
                $('.light-set1 .lightning-right').removeClass('lightning-active');
                $('.light-set1 .lightning-left').addClass('lightning-active');
            }

            if ($('.light-set2 .lightning-left').hasClass('lightning-active')) {
                $('.light-set2 .lightning-left').removeClass('lightning-active');
                $('.light-set2 .lightning-center').addClass('lightning-active');
            } else if ($('.light-set2 .lightning-center').hasClass('lightning-active')) {
                $('.light-set2 .lightning-center').removeClass('lightning-active');
                $('.light-set2 .lightning-right').addClass('lightning-active');
            } else {
                $('.light-set2 .lightning-right').removeClass('lightning-active');
                $('.light-set2 .lightning-left').addClass('lightning-active');
            }
        }, 500);
    }


    $('li[aria-haspopup="true"]').on('mouseout', function (e) {
        var that = $(this);
        timer = setTimeout(function () {
            $(".triggered-submenu").removeClass('expanded');
        }, 1000);
    })

    $('li[aria-haspopup="true"]').on('mouseover', function(e) {
        if(!$("#"+$(this).data('submenu')).hasClass('expanded')) {
            if(typeof timer !== 'undefined') {
                clearInterval(timer);
            }
        }
        if($('.triggered-submenu.expanded').length) $(".triggered-submenu").removeClass('expanded');
        $("#"+$(this).data('submenu')).addClass('expanded');
    })

    $('.skeleton-selector-wrap').on('mouseover', '.skeleton-selector-item', function(e) {
        if(!$(this).hasClass('enlarge')) {
            $('.skeleton-selector-wrap .skeleton-selector-item').removeClass('enlarge');
            $(this).addClass('enlarge');
            $('.skeleton-selector').attr('data-hand-position',$(this).index());
        }
    });

    $('.product-single__description_expand a').on('click', function(e) {
        e.preventDefault();

        if($('.product-single__description').hasClass('expanded')) {
            $('.product-single__description').removeClass('expanded');
            $(this).text("Read more");
        } else {
            $('.product-single__description').addClass('expanded');
            $(this).text("Read less");
        }
    })

    $('.qty-decrease').click(function(){
        current_val = parseInt($("#Quantity").val());

        if(current_val < 2) {
            $("#Quantity").val(1).trigger('change');
        }
        else {
            $("#Quantity").val(current_val - 1).trigger('change');
        }
        if($("#CSQuantity").length) {
            $("#CSQuantity").val($("#Quantity").val());
        }
    });

    $('.qty-increase').click(function(){
        current_val = parseInt($("#Quantity").val());

        $("#Quantity").val(current_val + 1).trigger('change');
        if($("#CSQuantity").length) {
            $("#CSQuantity").val($("#Quantity").val());
        }
    });

    if($("#Quantity").length) {
        $("#Quantity").on('change',function() {
            $('a[data-type="onetime"] span.singlebuy-price').text("$" + $('a[data-type="onetime"] span.singlebuy-price').data('default') * $("#Quantity").val());
            if($("#Quantity").val()<=4) {
                //$('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default-'+$("#Quantity").val()));
                $('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default')*$("#Quantity").val());
            } else {
                //$('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default-4'));
                $('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default')*4);
            }
            /*
            if($("#Quantity").val()>=3) {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 20%");
            } else if ($("#Quantity").val()==2) {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 15%");
            } else {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 10%");
            }*/
        })
    }

    $('.variant-selector a').click(function(e) {
        e.preventDefault();

        if(!$(this).hasClass('selected')) {
            $(this).closest('.variant-selector').find('a').removeClass('selected');
            $(this).addClass('selected');
            $(this).closest('.variant-selector').siblings('select.single-option-selector').val($(this).data('value')).trigger('change');
        }
    });

    $('.subscription-quantity a').click(function(e) {
        e.preventDefault();

        if(!$(this).hasClass('selected')) {
            $('.subscription-quantity a').removeClass('selected');
            $(this).addClass('selected');
            $('.subscription-quantity-description span').text(parseInt($(this).data('reference-quantity') * 20));
            $('input#Quantity').val(parseInt($(this).data('quantity')));
            $('.single-option-selector[data-option="bags"]').val($(this).data('value')).trigger('change');

            $('a[data-type="onetime"] span.singlebuy-price').text("$" + $('a[data-type="onetime"] span.singlebuy-price').data('default') * $(this).data('reference-quantity'));

            if ($(this).data('reference-quantity') <= 4) {
                //$('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default-' + $(this).data('reference-quantity')));
                $('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default') * $(this).data('quantity'));
            } else {
                //$('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default-4'));
                $('a[data-type="autodeliver"] span.ss-price').text("$" + $('a[data-type="autodeliver"] span.ss-price').data('default') * 4 );
            }
            /*
            if ($(this).data('reference-quantity') >= 3) {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 20%");
            } else if ($(this).data('reference-quantity') == 2) {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 15%");
            } else {
                $('a[data-type="autodeliver"] em.ss-save').text("Save 10%");
            }*/
        }
    });

    $('.subscription-period a').click(function(e) {
        e.preventDefault();

        if(!$(this).hasClass('selected')) {
            $('.subscription-period a').removeClass('selected');
            $(this).addClass('selected');
            $('select[name="properties[shipping_interval_frequency]"]').val($(this).data('value')).trigger('change');
        }
    });

    $('.subscribe-single a').click(function(e) {
        e.preventDefault();

        if(!$(this).hasClass('selected')) {
            $('.subscribe-single a').removeClass('selected');
            $(this).addClass('selected');

            if($(this).data('type')=="autodeliver") {
                $('.subscription-period').show();
                $('.subscription-quantity').show();
                $('.subscription-quantity-description').show();
                $('.qty-wrapper').hide();
                if($('input#Quantity').val() <= 4) {
                    if(!$('.subscription-quantity a[data-reference-quantity="'+$('input#Quantity').val()+'"]').hasClass('selected')) {
                        $('.subscription-quantity a[data-reference-quantity="'+$('input#Quantity').val()+'"]').trigger('click');
                    }
                } else {
                    if(!$('.subscription-quantity a[data-reference-quantity="4"]').hasClass('selected')) {
                        $('.subscription-quantity a[data-reference-quantity="4"]').trigger('click');
                    }
                    $('input#Quantity').val(4).trigger('change');
                }
            } else {
                $('.qty-wrapper').show();
                $('.subscription-period').hide();
                $('.subscription-quantity').hide();
                $('.subscription-quantity-description').hide();
                $('input#Quantity').val($('.subscription-quantity a.selected').data('reference-quantity')).trigger('change');
            }

            $('input[name="purchase_type"][value="'+$(this).data('type')+'"]').trigger('click');
        }
    });
/*
    if ($('.pdp_subscription_div').length) {
        var checkIfRechargeLoaded = setInterval(rechargeLoaded, 50);
        function rechargeLoaded() {
            if ($('form[action^="/cart/add"] button#AddToCart-product-template').css("visibility")=="visible") {
                $('.pdp_subscription_div').removeClass('hide');
                clearInterval(checkIfRechargeLoaded);
            }  else {
            }
        }
    }
*/
    /* COFFEE CLUB & GIFT */
    var subscriptionType = "club";
    var subscriptionProductId = "";
    var subscriptionVariantHandle = "";
    var subscriptionVariantId = "";
    var subscriptionProductQty = 2; //default changes to 1 for gifts
    var subscriptionRulesetId = "";
    var subscriptionRulesetPeriod = 1; //default changes to 6 for gifts
    var subscriptionRulesetUnit = "Weeks"; //default changes to "Months" for gifts
        window.addEventListener('popstate', (e) => { if (window.location.hash !== '#coffee-club') {$('.close-button').click();} else { $(".mobile-nav__sublist-link.join_the_club").click() } }) 
    $('#submenu-coffee-club div.img-container, .btn.join_the_club, .btn.give_a_gift, .mobile-nav__sublist-link.join_the_club, .mobile-nav__sublist-link.give_a_gift, .account-subscription-menu div.img-container, .account-subscription-menu a span').on('click', function(e) {
       window.location.href = "/pages/subscription-flow"
    });

    $('.coffee-club-overlay').on('click', '.close-button', function(e) {
        e.preventDefault();
        $('.coffee-club-overlay').hide();
        history.replaceState(undefined, undefined, "#")
        $('body').removeClass('has-full-height-overlay');
        $('.cco-content > div').removeClass('active');
        $('.subscription-type').addClass('active');
        $('.cco-header li').removeClass('active');
        $('.cco-header li[data-target="subscription-type"]').addClass('active');
        $('.cco-header li[data-target="gift-details"]').addClass('hide');
    });

    $('.cco-header ul:not(.mobile-selector)').on('click','li.active', function() {
        $(this).nextAll().removeClass('active');
        $('.cco-content > div.'+$(this).data('target')).nextAll().removeClass('active').removeClass('selected');
        $('.cco-content > div.' + $(this).data('target')).removeClass('selected').addClass('active');
    });
    $('.cco-header ul.mobile-selector').on('click','li.active', function() {
        $(this).nextAll().removeClass('active');
        $(this).removeClass('selected');
        $('.cco-header ul:not(.mobile-selector) li[data-parent="'+$(this).data('parent')+'"]');
        $('.cco-content > div.'+$(this).data('target')).nextAll().removeClass('active').removeClass('selected');
        $('.cco-content > div.' + $(this).data('target')).removeClass('selected').addClass('active');
    });

    $('.subscription-type-selector').on('click', function(e) {
        e.preventDefault();

        $('.subscription-type-selector').removeClass('selected');
        $(this).addClass('selected');
        if($(this).hasClass('gift-friend')) {
            $('.subscription-type-buttons, .type-buttons').removeClass('hide');
            $('.cco-header li[data-target="gift-details"]').removeClass('hide');
            $('.cco-header li[data-target="subscription-type"] em').text('Gift');

            subscriptionProductQty = 1; //Coffee club will always stay 1
            subscriptionRulesetPeriod = 6; //default changes to 6 for gifts

            $('.frequency-header span.club, .quantity-frequency .frequencies.club, .quantity-frequency .quantities.club ,.quantity-frequency .go-to-checkout').addClass('hide');
            $('.frequency-header span.gift, .quantity-frequency .frequencies.gift, .quantity-frequency .quantities.gift ,.quantity-frequency .go-to-gift-details').removeClass('hide');

            $('.quantities.gift a,.frequencies.gift a').removeClass('selected');
            $('.quantities.gift a[data-qty="' + subscriptionProductQty + '"], .frequencies.gift a[data-period="' + subscriptionRulesetPeriod + '"]').addClass('selected');

        } else {
            $('.subscription-type-buttons, .type-buttons').addClass('hide');
            $('.cco-header li[data-target="gift-details"]').addClass('hide');
            $('.subscription-type').addClass('selected').removeClass('active');
            $('.cco-header li[data-target="coffee-selector"]').addClass('active');
            $('.cco-header li[data-target="subscription-type"]').addClass('selected');
            $('.cco-header li[data-target="subscription-type"] em').text('Bones Club');
            $('.coffee-selector').addClass('active');
            subscriptionType = "club";
            subscriptionProductQty = 1; //Coffee club will always stay 1
            subscriptionRulesetPeriod = 2; //default changes to 6 for gifts

            $('.frequency-header span.club, .quantity-frequency .frequencies.club, .quantity-frequency .quantities.club ,.quantity-frequency .go-to-checkout').removeClass('hide');
            $('.frequency-header span.gift, .quantity-frequency .frequencies.gift, .quantity-frequency .quantities.gift ,.quantity-frequency .go-to-gift-details').addClass('hide');

            $('.quantities.club a,.frequencies.club a').removeClass('selected');
            $('.quantities.club a[data-qty="' + subscriptionProductQty + '"], .frequencies.club a[data-period="' + subscriptionRulesetPeriod + '"]').addClass('selected');
        }
    });

    $('.type-buttons').on('click', 'a', function(e) {
        e.preventDefault();

        subscriptionType = $(this).data("type");
        $('.subscription-type').addClass('selected').removeClass('active');
        $('.cco-header li[data-target="coffee-selector"]').addClass('active');
        $('.coffee-selector').addClass('active');
        $('.cco-header li[data-target="subscription-type"] em').text('Gift | '+ $(this).data("type").charAt(0).toUpperCase() + $(this).data("type").slice(1).replace(/-/g, ' '));


        //if gift
        if(subscriptionType != "club") {
            subscriptionProductQty = 1;
            subscriptionRulesetPeriod = 6;
            subscriptionRulesetUnit = "Months";

            $('.frequency-header span.club, .quantity-frequency .frequencies.club, .quantity-frequency .quantities.club ,.quantity-frequency .go-to-checkout').addClass('hide');
            $('.frequency-header span.gift, .quantity-frequency .frequencies.gift, .quantity-frequency .quantities.gift ,.quantity-frequency .go-to-gift-details').removeClass('hide');
        }
    });

    $('.coffee-type-selector').on('click', 'a', function(e) {
        e.preventDefault();

        if(!$(this).hasClass('selected')) {
            $('.buy-best:not([data-type="'+$(this).data('type')+'"]').addClass('hide');
            $('.buy-best[data-type="'+$(this).data('type')+'"]').removeClass('hide');
            $('.coffee-club-flavors .flavor:not([data-type="'+$(this).data('type')+'"])').addClass('hideForType');
            $('.coffee-club-flavors .flavor[data-type="'+$(this).data('type')+'"]').removeClass('hideForType');
            $(this).parent().siblings().find('a').removeClass('selected');
            $(this).addClass('selected');
        }

    });

    $('.flavor-filters').on('click', 'a', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('selected');
        if($('.flavor-filters li.selected').length) {
            $('.coffee-club-flavors .flavor').addClass('hideForFilter');
            $('.flavor-filters li.reset-filter').addClass('reset').text('Reset Filter');
            $.each($('.flavor-filters li.selected'), function(i,val) {
                $('.coffee-club-flavors .flavor[data-filter="' + $(this).find('a').data('filter') + '"]').removeClass('hideForFilter');
            })
        } else {
            $('.coffee-club-flavors .flavor').removeClass('hideForFilter');
            $('.flavor-filters li.reset-filter').removeClass('reset').text('Filter');
        }
    });
    $('.flavor-filters').on('click','.reset-filter', function() {
        $('.coffee-club-flavors .flavor').removeClass('hideForFilter');
        $('.flavor-filters li.selected').removeClass('selected');
        $('.flavor-filters li.reset-filter').removeClass('reset').text('Filter');
    })

    $('.buy-best, .coffee-club-flavors .flavors .flavor a').on('click', function(e) {
        e.preventDefault();

        subscriptionProductQty = 1;

        if(subscriptionType == "club") {
            subscriptionProductId = $(this).data('product-id');
            subscriptionVariantHandle = $(this).data('variant-handle');
            subscriptionVariantId = $(this).data('variant-id');
            subscriptionRulesetId = $(this).data('coffeeclub-ruleset-id');

            // default to 2 bags
            //subscriptionVariantId = coffeeClubJSON["2-bags"][subscriptionVariantHandle].variantId;
            //subscriptionRulesetId = coffeeClubJSON["2-bags"].rulesetId;
        } else {
            if($(this).hasClass('buy-best')) {
                subscriptionProductId = $('input[type="hidden"][data-variant-handle="' + $(this).data('variant-handle') + '"][data-handle="best-of-bones-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data('product-id');
                subscriptionVariantId = $('input[type="hidden"][data-variant-handle="'+$(this).data('variant-handle')+'"][data-handle="best-of-bones-'+subscriptionType+'-'+subscriptionRulesetPeriod+'"]').data('variant-id');
                subscriptionVariantHandle = $('input[type="hidden"][data-variant-handle="'+$(this).data('variant-handle')+'"][data-handle="best-of-bones-'+subscriptionType+'-'+subscriptionRulesetPeriod+'"]').data('variant-handle');
                subscriptionRulesetId = $('input[type="hidden"][data-variant-handle="'+$(this).data('variant-handle')+'"][data-handle="best-of-bones-'+subscriptionType+'-'+subscriptionRulesetPeriod+'"]').data(subscriptionType+subscriptionRulesetPeriod+'-ruleset-id');
            } else {
                subscriptionProductId = $('input[type="hidden"][data-variant-handle="' + $(this).data('variant-handle') + '"][data-handle="gift-subscription-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data('product-id');
                subscriptionVariantId = $('input[type="hidden"][data-variant-handle="'+$(this).data('variant-handle')+'"][data-handle="gift-subscription-'+subscriptionType+'-'+subscriptionRulesetPeriod+'"]').data('variant-id');
                subscriptionVariantHandle = $('input[type="hidden"][data-variant-handle="'+$(this).data('variant-handle')+'"][data-handle="gift-subscription-'+subscriptionType+'-'+subscriptionRulesetPeriod+'"]').data('variant-handle');
                subscriptionRulesetId = $('input[type="hidden"][data-variant-handle="' + $(this).data('variant-handle') + '"][data-handle="gift-subscription-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data(subscriptionType + subscriptionRulesetPeriod + '-ruleset-id');
            }
            
        }

        if(e.target.localName == 'a') {
            $('.flavors .flavor a.selected').removeClass('selected');
            $(this).addClass('selected');
        }

        $('.coffee-selector').addClass('selected').removeClass('active');
        $('.cco-header li[data-target="quantity-frequency"]').addClass('active');
        $('.cco-header li[data-target="coffee-selector"] em').text($(this).data('navigation-text'));
        $('.quantity-frequency').addClass('active');

        $('.coffee-club-overlay').scrollTop(0)

        //console.log(subscriptionType,subscriptionProductId,subscriptionVariantHandle, subscriptionProductQty,subscriptionRulesetId,subscriptionRulesetPeriod,subscriptionRulesetUnit,subscriptionVariantId)

    });

    $('ul.quantities').on('click','a', function(e) {
        e.preventDefault();

        subscriptionProductQty = $(this).data('qty');
        if(!$(this).hasClass('selected')) {
            $('ul.quantities a').removeClass('selected');
            $(this).addClass('selected');
        }

        if (subscriptionType == "prepaid" || subscriptionType == "monthly") {
            $.each($('.frequencies.gift a .price'), function (i, val) {
                $(this).text("$" + (parseInt(subscriptionProductQty) * $(this).data('default')));
            });            
        }
        //console.log(subscriptionType,subscriptionProductId,subscriptionVariantHandle, subscriptionProductQty,subscriptionRulesetId,subscriptionRulesetPeriod,subscriptionRulesetUnit,subscriptionVariantId)

    });

    $('ul.frequencies').on('click','a', function(e) {
        e.preventDefault();

        subscriptionRulesetPeriod = $(this).data('period');
        subscriptionRulesetUnit = $(this).data('unit');
        if (subscriptionType == "prepaid" || subscriptionType == "monthly") {
            if (subscriptionVariantHandle == "coffee-club-best-of-bones-single-serve" || subscriptionVariantHandle == "coffee-club-best-of-bones-whole-bean" || subscriptionVariantHandle == "coffee-club-best-of-bones-ground") {
                subscriptionRulesetId = $('input[data-variant-handle="' + subscriptionVariantHandle + '"][data-handle="best-of-bones-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data(subscriptionType + subscriptionRulesetPeriod + '-ruleset-id');
                subscriptionVariantId = $('input[data-variant-handle="' + subscriptionVariantHandle + '"][data-handle="best-of-bones-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data('variant-id');
            } else {
                subscriptionRulesetId = $('input[data-variant-handle="' + subscriptionVariantHandle + '"][data-handle="gift-subscription-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data(subscriptionType + subscriptionRulesetPeriod + '-ruleset-id');
                subscriptionVariantId = $('input[data-variant-handle="' + subscriptionVariantHandle + '"][data-handle="gift-subscription-' + subscriptionType + '-' + subscriptionRulesetPeriod + '"]').data('variant-id');
            }
            //console.log(subscriptionType, subscriptionProductId, subscriptionVariantHandle, subscriptionProductQty, subscriptionRulesetId, subscriptionRulesetPeriod, subscriptionRulesetUnit, subscriptionVariantId)
        }
        if(!$(this).hasClass('selected')) {
            $('ul.frequencies a').removeClass('selected');
            $(this).addClass('selected');
        }
    });


    $('.checkbox.is-gift').on('click', function() {
        $(this).toggleClass('checked');
    });

    $('.go-to-gift-details').on('click', function(e) {
        e.preventDefault();

        $('.quantity-frequency').addClass('selected').removeClass('active');
        $('.cco-header li[data-target="gift-details"]').addClass('active');
        $('.cco-header li[data-target="quantity-frequency"] em').text(subscriptionProductQty + " bag" + (subscriptionProductQty>1 ? "s": "" ) + " every month for "+subscriptionRulesetPeriod+" "+subscriptionRulesetUnit);
        $('.gift-details').addClass('active');

        textareaMaxLength($('textarea[name="gift-message"]'));
    })

    $('.go-to-checkout').on('click', function(e) {
        e.preventDefault();

        
        if(subscriptionType!="club") {
            subscriptionData = {
                "quantity": subscriptionProductQty,
                "id": subscriptionVariantId,
                "properties[shipping_interval_frequency]": 1,
                "properties[shipping_interval_unit_type]": subscriptionRulesetUnit,
                "properties[subscription_id]": subscriptionRulesetId,
                "properties[charge_interval_frequency]": subscriptionRulesetPeriod,
                "properties[charge_interval_unit_type]": subscriptionRulesetUnit,
            }
        } else {
            subscriptionData = {
                "quantity": subscriptionProductQty,
                "id": subscriptionVariantId,
                "properties[shipping_interval_frequency]": subscriptionRulesetPeriod,
                "properties[shipping_interval_unit_type]": subscriptionRulesetUnit,
                "properties[subscription_id]": subscriptionRulesetId
            }
        }

        if($('textarea[name="gift-message"]').val()!="") {
            $.ajax({
        		url: '/cart/update.js',
        		type: 'POST',
        		data: {note: $('textarea[name="gift-message"]').val()},
        		success: function(result) {
        		},
        		error: function(jqxhr, status, exception) {
        		},
                complete: function() {
                    if($('.is-gift').hasClass('checked')) {
                        $.ajax({
                            url: '/cart/add.js',
                            type: 'POST',
                            data: {
                                "quantity": 1,
                                "id": $('.is-gift').data('variant-id')
                            },
                            dataType: 'json',
                            success: function(result) {
                            },
                            error: function(jqxhr, status, exception) {
                            },
                            complete: function() {
                                addSubscriptionToCart(subscriptionData);
                            }
                        });
                    } else {
                        addSubscriptionToCart(subscriptionData);
                    }
                }
    		});
        } else {
            if($('.is-gift').hasClass('checked')) {
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    data: {
                        "quantity": 1,
                        "id": $('.is-gift').data('variant-id')
                    },
                    dataType: 'json',
                    success: function(result) {
                    },
                    error: function(jqxhr, status, exception) {
                    },
                    complete: function() {
                        addSubscriptionToCart(subscriptionData);
                    }
                });
            } else {
                addSubscriptionToCart(subscriptionData)
            }
        }
    });

    if($('.choice-selector').length) {
        var selectedFlavors = [];
    }

    $('#chooseSampleFlavors').on('click', function(e) {
        e.preventDefault();

        $('.choice-selector').show();
        $('body').addClass('has-full-height-overlay');
    })

    $('.choice-selector .close-button').on('click', function(e) {
        e.preventDefault();
        $('.choice-selector').hide();
        $('body').removeClass('has-full-height-overlay');
    });

    $('.flavor').on('click', '.flavor-add:not(.added)', function(e){
        e.preventDefault();
        if(countChoices()<5) {
            $(this).addClass('added');
            $(this).find('.count').data('count',$(this).find('.count').data('count')+1).text($(this).find('.count').data('count'));
            selectedFlavors.push($(this).closest('a').data('product-flavor'));
            $(this).parent().addClass('selected');
            $('#remaining-choices').text(5-countChoices());
        }
    });
    $('.flavor').on('click', '.flavor-add.added .plus, .flavor-add.added .minus', function(e) {
        e.preventDefault();
        if($(this).hasClass('plus')) {
            if(countChoices()<5) {
                $(this).siblings('.count').data('count',$(this).siblings('.count').data('count')+1).text($(this).siblings('.count').data('count'));

                selectedFlavors.push($(this).closest('a').data('product-flavor'));
            }
        } else {
            $(this).siblings('.count').data('count',$(this).siblings('.count').data('count')-1).text($(this).siblings('.count').data('count'));
            if($(this).siblings('.count').data('count')==0) {
                $(this).closest('a').removeClass('selected');
                $(this).closest('.flavor-add').removeClass('added');
                selectedFlavors = removeElement(selectedFlavors,$(this).closest('a').data('product-flavor'));
            } else {
                selectedFlavors = removeElement(selectedFlavors,$(this).closest('a').data('product-flavor'));
            }
        }
        $('#remaining-choices').text(5-countChoices());
    })

    $('.input#CSQuantity').on('change', function(e) {
        $('.input[name="quantity"]').val($(this).val());
    });

    $('.variant-selector').on('click', 'a', function(e) {
        if(!$('.grinds-buttons a[data-grind="'+$(this).data('value')+'"]').hasClass('selected')) {
            $('.grinds-buttons a').removeClass('selected');
            $('.grinds-buttons a[data-grind="'+$(this).data('value')+'"]').addClass('selected');
        }
    });

    $('.grinds-buttons').on('click', 'a', function(e) {
        e.preventDefault();
        $('.variant-selector a[data-value="'+$(this).data('grind')+'"]').trigger('click');
    })

    $('.cs-footer-block').on('click', '.add-sample-to-cart:not(.disabled)', function(e) {
        e.preventDefault();
        var variantId = $('#ProductSelect-product-sample-pack-template').val();
        var qty = $('#CSQuantity').val();
        selectedFlavors.sort();
        var properties = {
            "Bag 1": selectedFlavors[0].replace(" | 12oz",""),
            "Bag 2": selectedFlavors[1].replace(" | 12oz", ""),
            "Bag 3": selectedFlavors[2].replace(" | 12oz", ""),
            "Bag 4": selectedFlavors[3].replace(" | 12oz", ""),
            "Bag 5": selectedFlavors[4].replace(" | 12oz", "")
        }

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {
                "quantity": qty,
                "id": variantId,
                "properties": properties
            },
            dataType: 'json',
            success: function(result) {
                $('.flavor a').removeClass('selected');
                selectedFlavors = [];
                resetChoiceSelector();
                ajaxCart.load();
                theme.RightDrawer.open();
                $('body').removeClass('has-full-height-overlay');
            },
            error: function(jqxhr, status, exception) {
            },
            complete: function() {

            }
        });

    })

    $('.collections-list .small-header').on('click', 'a', function(e) {
        e.preventDefault();
        $(this).closest('.collections-list').toggleClass('expanded');
    })

    $('body').on('click', '.cart__checkout', function(e) {
        e.preventDefault();
        var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'text',
            success: function(data) {
                if (data.indexOf("subscription_id") > -1) {
                    var paramDomain = 'myshopify_domain=bones-coffee-company.myshopify.com';
                    try {
                        var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
                    } catch (err) {
                        var paramLinker = '';
                    }
                    var paramCustomer = '';
                    window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer;
                } else {
                    window.location = '/checkout';
                }
            }
        });
    });

    $('select[name="order-types"]').on('change', function() {
        var selectVal = $(this).val();

        if(selectVal == "all") {
            $('.order-item').show();
        } else if (selectVal == "single") {
            $('.order-item').show();
            $('.order-item.subscription').hide();
        } else {
            $('.order-item').hide();
            $('.order-item.subscription').show();
        }

    });

    /* RECHARGE */
    if($('#rc_navigation').length) {

        $('body').addClass('recharge-tool');

        $('#rc_navigation').append('<li style="margin-top: 30px;"><a href="/account/addresses">Address book</a></li>');
        $('#rc_navigation').append('<li><a href="/account#order-history" data-target="#order-history">Order history</a></li>');
        $('#rc_navigation').append('<li><a href="/account#account-details" data-target="#account-details">Account details</a></li>');
        $('#rc_navigation').append('<li><a href="/account/logout">Log out</a></li>');

        if($('.rc_title-bar__title').length && $('.rc_title-bar__title h2').text() == "Purchase history") {
            $("#rc_navigation .rc_menu__item:eq(3) a").addClass("active"); // Purchase history - active
        }

        if($("#content__customers__deliver-schedule").length) {
            $.each($('.rc_schedule__order'), function(i, val) {
                var date = $(this).find('.rc__schedule__orders__order__date').html();
                var address = $(this).find('.rc_schedule__order__address').html();
                if (address == null) address = "";
                var table = $(this).find('.rc_schedule__order__items');
                table.find('th:eq(1)').text('Qty');
                table.find('th.td-product').after('<th class="rc_text--right">Delivery</th>');
                $.each(table.find('tr.rc_schedule__order__item'), function (j, value) {
                    $(this).find('td:eq(0)').after('<td class="delivery-address">'+date+' <br/> '+address+'</td>');
                    $(this).find('td:eq(0)').css({"width": "30%"});
                    $(this).find('td:eq(1)').css({"width": "30%"});
                });
            });
        }

        //$('#content__customers__subscriptions .rc_header-settings__title h2').text("Last Subscription")

        
        $.each($('.rc_subscriptions__subscription .rc_subscriptions__subscription__items tbody tr'), function(i, val) {
            var next_charge = $(this).find('.rc_subscriptions__subscription__item__date').text().toLowerCase().trim();
            //if(next_charge == "cancelled") $(this).hide();
            var edit_link = $(this).find('.edit-item-link').attr('href');
            var product_name = $(this).find('.td-product p').text();
            var product_name_split = product_name.split(" - ");
            var product_price = $(this).find('.td-price').text();
            var product_qty = $(this).find('.td-amount').text();
            var product_address1 = $(this).closest('.rc_subscriptions__subscription').find('.rc_subscriptions__subscription__address__address_1').text();
            var product_city = $(this).closest('.rc_subscriptions__subscription').find('.rc_subscriptions__subscription__address__city').text();
            var product_zipcode = $(this).closest('.rc_subscriptions__subscription').find('.rc_subscriptions__subscription__address__zipcode').text();

//<div class="subscription-header"><span></span><span>December 20, 2019</span></div> 
            var boxes = `
            <div class="subscription-box subscription-left">
            <h2>Subscription Product</h2>
        <div class="subscription-content">
            <h3>` + product_name_split[0] + `</h3>
            <h4>` + product_name_split[1] + `</h4>
            <a href="`+ edit_link +`" class="manage">Manage subscription</a>
        </div>        
        <div class="subscription-footer">
            <a href="#">See all subscriptions</a>
        </div>
    </div>
    
    <div class="subscription-box subscription-right">
        <h2>Next charge</h2>
        <div class="subscription-content">
            <h3>`+ next_charge +`</h3>
            <div class="next-details">
                <span class="price">$`+ product_price +`</span> <span class="quantity">Quantity: `+ product_qty +`</span>
            </div>
            <p class="order-address">`+ product_address1 +`<br/>`+ product_city +`, `+ product_zipcode +`</p>

            <div><a href="`+ edit_link +`" class="skip-edit">Edit</a></div>
        </div>        
        <div class="subscription-footer">
            <a href="`+ $('#rc_navigation').find('.rc_menu__item:eq(0) a').attr('href') +`">See complete delivery schedule</a>
        </div>
    </div>`;

            $(this).closest('.rc_subscriptions__subscription').append(boxes);
        });

        if($("#content__customers__subscriptions__items #rc_subscriptions__items__variant").length) {
            if(!$('.rc_title-bar__title h2').text().toLowerCase().includes('prepaid')) {
                $("#content__customers__subscriptions__items #rc_subscriptions__items__variant").show();
            }
        }
    }

    
});

function resetChoiceSelector() {
    $('.choice-selector').hide();
    selectedFlavors = [];
    $('.flavors .flavor .flavor-add').removeClass('added');
    $('.flavors .flavor .count').data('count',0).text("0");
}

function removeElement(arr, el) {
    var indexOfEl = arr.indexOf(el);
    delete arr[indexOfEl];

    arr = arr.filter(function (el) {
        return el != null;
    });

    return arr;
}

function countChoices() {
    var choiceCount = 0;
    $.each($('.flavor-add.added'),function(i,val) {
        choiceCount += $(this).find('.count').data('count');
    });
    if(choiceCount>=5) $('.add-sample-to-cart').removeClass('disabled');
    else {
        if(!$('.add-sample-to-cart').hasClass('disabled')) $('.add-sample-to-cart').addClass('disabled');
    }
    return choiceCount;
}

function addSubscriptionToCart(data) {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'text',
                success: function(data) {
                    if (data.indexOf("subscription_id") > -1) {
                        var paramDomain = 'myshopify_domain=bones-coffee-company.myshopify.com';
                        try {
                            var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
                        } catch (err) {
                            var paramLinker = '';
                        }
                        var paramCustomer = '';
                        window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer;
                    } else {
                        window.location = '/checkout';
                    }
                }
            });
        }

    });
}

function textareaMaxLength(el) {
    var max = el.data('maxLength');
    el.onkeypress = function () {
        if (this.value.length >= max) return false;
    };
}
